import { Assets, TemplateSets } from '@/utils/pattern-assets'
import type { WizardAsset, WizardColorOption } from './types'

const ASSET_ROOT = '/assets/patterns/'

export function patternThumb(path?: string): string {
  if (!path) return ''
  if (path.startsWith('http') || path.startsWith('/')) return path
  return `${ASSET_ROOT}${path}`
}

/** All gallery room templates for the wizard */
export function getWizardScenes(_limit?: number): WizardAsset[] {
  const list = TemplateSets.GalleryTemplates || []
  return list.map((t) => ({
    id: t.id,
    name: t.name,
    thumbUrl: patternThumb(t.thumb),
    assetPath: t.url,
  }))
}

export function getWizardFrames(_limit?: number): WizardAsset[] {
  const list = Assets.frames || []
  return list.map((t) => ({
    id: t.id,
    name: t.name,
    thumbUrl: patternThumb(t.thumb),
    assetPath: t.url,
  }))
}

export function getWizardMaterials(_limit?: number): WizardAsset[] {
  const list = Assets.materials || []
  return list.map((t) => ({
    id: t.id,
    name: t.name,
    thumbUrl: patternThumb(t.thumb),
    assetPath: t.albedo,
  }))
}

/** Flatten color swatches into single-hex options for the wizard */
export function getWizardColors(_limit?: number): WizardColorOption[] {
  const swatches = Assets.colors || []
  const out: WizardColorOption[] = []
  for (const s of swatches) {
    const hexes = s.hex || []
    const pick = hexes[1] || hexes[0]
    if (!pick) continue
    out.push({
      id: `${s.name}-${pick}`,
      name: s.name,
      hex: pick,
      applyHex: hexes[0],
    })
  }
  return out
}

// Standalone matting-color literals — not part of an `Assets.colors` swatch
// family, so there's no separate "identity" hex; display and apply match.
export const MAT_COLORS: WizardColorOption[] = [
  { id: 'mat-ivory', name: 'Ivory', hex: '#F5F0E8', applyHex: '#F5F0E8' },
  { id: 'mat-white', name: 'White', hex: '#FFFFFF', applyHex: '#FFFFFF' },
  { id: 'mat-warm', name: 'Warm gray', hex: '#D4CFC7', applyHex: '#D4CFC7' },
  { id: 'mat-charcoal', name: 'Charcoal', hex: '#2C2C2C', applyHex: '#2C2C2C' },
  { id: 'mat-black', name: 'Black', hex: '#111111', applyHex: '#111111' },
  { id: 'mat-navy', name: 'Navy', hex: '#1E293B', applyHex: '#1E293B' },
]

export const DEFAULT_SLOT_COUNT = 8
